module.exports = __webpack_public_path__ + "static/media/downloadRegular.05f6ea69.svg";